import { UserManager, UserManagerSettings, User } from 'oidc-client'
import { WebStorageStateStore } from 'oidc-client'
import { GetConfiguration } from '../utils/config';
import { IGlobalState } from '../states/GlobalState';
import { Principal } from '../models/principal';
import { LivelloAutorizzazioneContextsOptions, LivelloAutorizzazioneOptions } from './constants';

export const configIForf: UserManagerSettings = {
    client_id: GetConfiguration().client_id,    //'dbe4a355-f85e-4911-96ea-36330e2cbef3',
    client_secret: GetConfiguration().client_id,    
    redirect_uri: `${GetConfiguration().base_url}callback`,
    response_type: 'code',
    scope: 'openid profile sixinfo authinfoapi iforf.api',
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    automaticSilentRenew: false,    // Added for Easy start SSO
    filterProtocolClaims: true,
    loadUserInfo: true,
    post_logout_redirect_uri: `${GetConfiguration().base_url}`,
    userStore: new WebStorageStateStore({ store: localStorage })  // Questo è il Default di dove salva i dati di autenticazione
}

const config = configIForf;

const createUserManager = (config: UserManagerSettings) => {
    return new UserManager(config);
}

const getDefaultUserManager = () => {
    console.log('getDefaultUserManager: inizio')
    const userManager = createUserManager(config)
    console.log('getDefaultUserManager: fine', {userManager})
    return userManager;
}

const getAuthData = (accessToken: string, signal: AbortSignal) => {
    const bearer = 'Bearer ' + accessToken
    const options = {
        //signal: signal,
        headers: {
            'Authorization': bearer,
        }
    }
    const url = `${process.env.REACT_APP_AUTH_AUTHORITY}identity`;
    console.warn(url, {options})
    return window.fetch(url, options)
        .then(resp => resp.json())
        .then(json => {
            console.log(json);
            return json.authData as AuthDataType;
        })
        .catch(error => console.error(error))
}

export const saveHideLoginInSession = () => {
    sessionStorage.setItem('hideLogin', '1');
}

export const clearHideLoginFromSession = () => {
    sessionStorage.removeItem('hideLogin');
}

export const saveIdentityInStorage = (identity: Principal) => {
    localStorage.setItem('identitySSO', JSON.stringify(identity));
}

export const clearIdentityFromStorage = () => {
    localStorage.removeItem('identitySSO');
}

export const getIdentityFromStorage = (): Principal | null => {
    let identity: Principal | null = null;
    const temp = localStorage.getItem('identitySSO');
    if (temp)
      identity = JSON.parse(temp) as Principal;

    return identity;
}

const localStorageAuthDataKey = (user: User) => `authData.${user.session_state}`

export const saveAuthData = (authData: AuthDataType | null, user: User) => {
    if(authData) {
        localStorage.setItem(localStorageAuthDataKey(user), JSON.stringify(authData));
    } else {
        clearAuthDataStorage(user);
    }
}
export const clearAuthDataStorage = (user: User) => localStorage.removeItem(localStorageAuthDataKey(user));
export const retrieveAuthData = (user: User) => {
    const temp = localStorage.getItem(localStorageAuthDataKey(user))
    if(temp) {
        return JSON.parse(temp) as AuthDataType
    }
    return null;
}

export type AuthDataType = {
    alias: string,
    codice: string | null,
    codici: string[] | null,
    email: string,
    province: string[] | null,
    provinciaDefault: string | null,
    role: string,
    token: string,
    uffici: string[] | null,
    ufficioDefault: string | null,
    user: string,
    userData: string | null,
}

export interface IAuth {
    userManager: UserManager,
    user: User | null,
    authData: AuthDataType | null
}

export interface DevAuth{
    prov: string;
    sede: string;
    username: string;
}

export function getLevels(auth: AuthDataType | null) {
    if(auth) {
        return LivelloAutorizzazioneContextsOptions[auth.role]
    }
    return LivelloAutorizzazioneOptions
}

export function getUsername(global: IGlobalState): string {
    // return GetConfiguration().sviluppo ? global.devAuth.username : global.auth.authData!.user;
    if (global.auth.authData)
        return global.auth.authData!.user;
    return "";
}

export function getProvincia(global: IGlobalState){
    // return GetConfiguration().sviluppo ? global.devAuth.prov : global.auth.authData!.provinciaDefault;
    // FIXME
    if (global.auth.authData) {
        console.log('provincia default: ' + global.auth.authData!.provinciaDefault);
        return global.auth.authData!.provinciaDefault;
    }
    // return "44";
}

export function getVersion(){
    return GetConfiguration().versione;
}


export default {
    getDefaultUserManager,
    getAuthData,
    saveAuthData,
    createUserManager,
    config,
    getUsername,
    getProvincia,
    getVersion,
}
